<template>
    <div v-if="selectedPaymentMethod">
        <font-awesome-icon :icon="icon" class="pr-3"/>
        {{ getText }} {{ validUntil }}
    </div>
</template>

<script>
export default {
    name: 'StripeCardInfo',
    props: {
        selectedPaymentMethod: {
            type: Object,
            required: true
        }
    },
    methods: {

    },
    computed: {
        icon() {
            switch(this.selectedPaymentMethod.card.brand) {
                case "visa":
                    return "fab fa-cc-visa"
                case "mastercard":
                    return "fab fa-cc-mastercard"
                default:
                    return "fas fa-credit-card-front"
            }
        },
        validUntil() {
            const month = (this.selectedPaymentMethod.card.exp_month < 10 ? '0' : '') + this.selectedPaymentMethod.card.exp_month;
            return month + '/' + this.selectedPaymentMethod.card.exp_year
        },
        getText() {
            const brand = this.$t('co.payment_methods.card.brand.'+this.selectedPaymentMethod.card.brand)
            return this.selectedPaymentMethod ? `${brand}, ${this.$t('co.payment_methods.card.last4')} ${this.selectedPaymentMethod.card.last4 }, ${this.$t('co.payment_methods.card.valid_until')}` : ''
        },
    }
}
</script>
